import './icons/fontAwesome';
import './scss/main.scss';
import './shared/polyfills';
import 'leaflet-defaulticon-compatibility';

import {registerAiConsentInterception} from '@/naja/aiConsent';
import {registerAjaxLinkListeners} from '@/naja/ajaxLinks';
import {bindInemComponents} from '@/naja/components';
import {initializeLinksThatRequireConfirmation} from '@/naja/confirmDialog';
import {registerFileUploadCountListeners} from '@/naja/FileUploadCount';
import {loadLazySnippets} from '@/naja/LazySnippets';
import {openAjaxModals} from '@/naja/modals';
import initializePoller from '@/naja/Poller';
import {ProgressBar} from '@/naja/ProgressBar';
import {SessionExpiredHandler} from '@/naja/SessionExpiredHandler';
import {SnippetProcessor} from '@/naja/SnippetProcessor';
import 'chart.js/auto';
import naja from 'naja';

import {registerZoningPlanEnhancements} from '@/cadastre/zoningPlan';
import {registerZoningPlanPages} from '@/zoningPlan/pages';
import {registerShopPage} from '@/shop/shopPage';
import {registerDocumentLookup} from '@/cadastre/documentLookup';
import {AutoScrollExtension} from '@/naja/AutoScrollExtension';
import {AutoSubmitFormElementExtension} from '@/naja/AutoSubmitFormElementExtension';
import LazyLoading from '@/naja/LazyLoading';
import {initializeReCaptcha} from '@/naja/reCaptcha';
import {initializeCookieConsent} from '@/shared/cookieConsent';
import {initializeSentry} from '@/shared/sentry';
import moment from 'moment';
// @ts-ignore
import netteForms from '../../vendor/nette/forms/src/assets/netteForms';

initializeSentry();
initializeCookieConsent();

// Use czech language for dates
moment.locale('cs');

naja.formsHandler.netteForms = netteForms;
naja.registerExtension(SnippetProcessor, initializeLinksThatRequireConfirmation);
naja.registerExtension(SnippetProcessor, registerAiConsentInterception);
naja.registerExtension(SnippetProcessor, registerAjaxLinkListeners);
naja.registerExtension(SnippetProcessor, registerFileUploadCountListeners);
naja.registerExtension(SnippetProcessor, openAjaxModals);
naja.registerExtension(SnippetProcessor, bindInemComponents);
naja.registerExtension(SnippetProcessor, initializeReCaptcha);
naja.registerExtension(SnippetProcessor, initializePoller);
naja.registerExtension(SnippetProcessor, registerZoningPlanEnhancements);
naja.registerExtension(SnippetProcessor, registerZoningPlanPages);
naja.registerExtension(SnippetProcessor, registerShopPage);
naja.registerExtension(SnippetProcessor, registerDocumentLookup);
naja.registerExtension(SnippetProcessor, loadLazySnippets);
naja.registerExtension(ProgressBar);
naja.registerExtension(SessionExpiredHandler);
naja.registerExtension(AutoScrollExtension);
naja.registerExtension(LazyLoading);
naja.registerExtension(AutoSubmitFormElementExtension);

document.addEventListener('DOMContentLoaded', () => {
    // Prevents NS_ERROR_ILLEGAL_VALUE on large pages in Firefox
    naja.historyHandler.historyAdapter = {
        replaceState: () => {},
        pushState: () => {},
    };

    naja.initialize({history: false, timeout: 120000});
});

